import { render, staticRenderFns } from "./FormularOdoslany.vue?vue&type=template&id=235bb452&scoped=true"
var script = {}
import style0 from "./FormularOdoslany.vue?vue&type=style&index=0&id=235bb452&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235bb452",
  null
  
)

export default component.exports